module.exports = __webpack_public_path__ + "img/calendar-week.bb3baa96.svg";